"use client";

import React, { useRef, useState, useEffect } from "react";

import Image from "next/image";
import CornerChip from "@/components/global/ui/CornerChip";

import { cn } from "@/lib/utils";
import { PortableText } from "@portabletext/react";
import { richTextComponent } from "@/sanity/sanityPortableText";
import { CTACornerButton } from "@/shadcn/ui/corner-button";
import {
  HLSVideoPlayer,
  SanityVideoPlayer,
} from "@/components/ui/SanityVideoPlayer";
import { Dialog, DialogContent } from "@/shadcn/ui/dialog";

import { PageAboutSchema } from "@/sanity/pages/PageAboutTemplate";

import volumeMute from "@/public/icons/Volume--mute--filled.svg";
import volumeUnmute from "@/public/icons/Volume--up--filled.svg";
import maximize from "@/public/icons/Maximize.svg";
import screenEffect from "@/public/about/screen-effect.svg";
import { PageInnerCircleSchema } from "@/sanity/pages/PageInnerCircleTemplate";
import Chip from "../global/ui/Chip";
import Divider from "../global/ui/Divider";
import DividerGreenLine from "../global/ui/DividerGreenLine";
import ChipScrollingBanner from "../global/ui/ChipScrollingBanner";
import GridNoise from "../global/ui/GridNoise";
import { GROQImage } from "@/sanity/lib/types";
import { PortableTextBlock } from "sanity";

interface CardGridProp {
  className?: string;
  cards: {
    icon: GROQImage;
    text: PortableTextBlock[];
  }[];
}

function Card({
  card,
}: {
  card: {
    icon: GROQImage;
    text: PortableTextBlock[];
  };
}) {
  return (
    <div className="border border-black/20 p-[3rem] flex flex-col items-center gap-[2rem]">
      <Image src={card.icon} alt="icon" className="!w-[5rem]" />
      <div className="richtext richtext-center prose-headings:mt-0 prose-headings:font-medium prose-headings:text-black prose-headings:text-[2.25rem] prose-headings:font-geist prose-p:text-black/70 prose-p:text-[2rem] lg:prose-p:text-[2.25rem]">
        <PortableText value={card.text} components={richTextComponent} />
      </div>
    </div>
  );
}

export default function CardGrid({ className, cards }: CardGridProp) {
  return (
    <section
      className={cn(
        "relative grid grid-cols-1 lg:grid-cols-3 gap-[1rem] lg:gap-[6rem]",
        className,
      )}
    >
      {cards.map((card, index) => (
        <Card key={"card" + index} card={card} />
      ))}
    </section>
  );
}
